import { useTranslation } from "react-i18next";
import { ChevronDown, Users } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover/index.js";
import { cn } from "../../lib/utils.js";
import { ContactGroupPreview } from "../contacts/ContactGroupPreview.js";

export const campaignSourceChipClass =
  "inline-flex h-6 shrink-0 items-center gap-1 rounded-full border border-line/70 bg-surface-muted px-2 text-[0.7rem] text-foreground";

/** Compact "N groups" chip that lists the selected group names in a popover. */
export function CampaignGroupsPopover({
  groups,
  count = groups.length,
  testId,
}: {
  groups: ReadonlyArray<{ id: number; name: string }>;
  count?: number;
  testId?: string;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            campaignSourceChipClass,
            "cursor-pointer transition-colors hover:border-accent/30 hover:bg-accent/5 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--color-ring)] data-[state=open]:border-accent/30 data-[state=open]:bg-accent/5",
          )}
          data-testid={testId}
        >
          <Users size={11} className="shrink-0 text-muted" aria-hidden="true" />
          {t("campaigns.sources.groupsChip", { count })}
          <ChevronDown size={11} className="shrink-0 text-muted" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="grid gap-2 p-3" data-testid="campaign-groups-popover">
        <p className="m-0 text-[0.75rem] font-semibold text-foreground">
          {t("campaigns.sources.selectedGroups")}
        </p>
        <ContactGroupPreview groups={groups} collapsible />
      </PopoverContent>
    </Popover>
  );
}
